import React from 'react'
import RegisterCompanyList from '../../../../Components/settings/Company/RegisterCompany/RegisterCompanyList'
function RegisteredCompanyListingPage() {
    return (
        <div className="page-body">

            <RegisterCompanyList />
        </div>
    )
}

export default RegisteredCompanyListingPage